import type { ListItemComponent, ListItemProps } from './ListItem.types'
import cn from 'classnames'
import React from 'react'
import styles from './ListItem.module.css'

function ListItemBase({
  ref,
  children,
  hasHover,
  variant = 'outlined',
  container = 'M',
  className,
  as,
  onClick,
  ...rest
}: ListItemProps<React.ElementType>) {
  const Component: React.ElementType = as ?? 'div'
  const isVariantBase = variant === 'divider' || variant === 'tinted' || variant === 'outlined'

  return (
    <Component
      ref={ref}
      onClick={onClick}
      className={cn(
        {
          [styles.variantBase]: isVariantBase,
          [styles.transparent]: variant === 'transparent',
          [styles.divider]: variant === 'divider',
          [styles.tinted]: variant === 'tinted',
          [styles.hasHoverTinted]: hasHover && variant === 'tinted',
          [styles.outlined]: variant === 'outlined',
          [styles.hasHoverTransparent]: hasHover && variant === 'transparent',
          [styles.hasHoverDivider]: hasHover && variant === 'divider',
          [styles.containerS]: container === 'S',
        },
        className,
      )}
      {...rest}
    >
      {children}
    </Component>
  )
}

ListItemBase.displayName = 'ListItem'

export const ListItem: ListItemComponent = ListItemBase
